import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import {
  hasPermission,
  canAccessRoute,
  isSeller,
  isWholesaler,
  getStoreType,
  getStorePermissions,
  Permission,
} from "@/lib/rbac";

/**
 * Hook to easily access role-based permissions in React components
 */
export function usePermissions() {
  const currentStore = useSelector(
    (state: RootState) => state.auth.currentStoreInfo,
  );

  return {
    // Store type checks
    isSeller: isSeller(currentStore),
    isWholesaler: isWholesaler(currentStore),
    storeType: getStoreType(currentStore),
    currentStore,

    // Permission checks
    hasPermission: (permission: Permission) =>
      hasPermission(currentStore, permission),
    canAccessRoute: (routePath: string) =>
      canAccessRoute(currentStore, routePath),
    getAllPermissions: () => getStorePermissions(currentStore),

    // Common permission shortcuts
    canManageCoupons: hasPermission(currentStore, Permission.VIEW_COUPONS),
    canCreateCoupons: hasPermission(currentStore, Permission.CREATE_COUPONS),
    canBulkUpload: hasPermission(currentStore, Permission.BULK_UPLOAD_PRODUCTS),
    canExportData: hasPermission(currentStore, Permission.EXPORT_DATA),
    canManageUsers: hasPermission(currentStore, Permission.MANAGE_USERS),
  };
}
